import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { JugadorOfflineAssertions } from '../../system/PlanillaPartidoOffline/JugadorOfflineAssertions';

class JugadorOfflineForm extends CustomForm {
  protected constructor(
    jugo_id: string | null,
    jugo_tipo_doc: string,
    jugo_nro_doc: string,
    jugo_nombre: string,
    jugo_apellido: string
  ) {
    const jugoff = JugadorOfflineAssertions.build();
    super('JugadorOffline', jugoff);
    this.addInputAsserted('jugo_id', jugo_id);
    this.addInput('jugo_tipo_doc', jugo_tipo_doc);
    this.addInput('jugo_nro_doc', jugo_nro_doc);
    this.addInput('jugo_nombre', jugo_nombre);
    this.addInput('jugo_apellido', jugo_apellido);
  }

  private static build(
    jugo_id: string | null,
    jugo_tipo_doc: string,
    jugo_nro_doc: string,
    jugo_nombre: string,
    jugo_apellido: string
  ) {
    return new this(jugo_id, jugo_tipo_doc, jugo_nro_doc, jugo_nombre, jugo_apellido);
  }

  static initialize() {
    return this.build(null, '', '', '', '');
  }

  getIdInput() {
    return this.getInputByName('jugo_id');
  }

  getTipoDocInput() {
    return this.getInputByName('jugo_tipo_doc');
  }

  getNroDocInput() {
    return this.getInputByName('jugo_nro_doc');
  }

  getNombreInput() {
    return this.getInputByName('jugo_nombre');
  }

  getApellidoInput() {
    return this.getInputByName('jugo_apellido');
  }
}

export default JugadorOfflineForm;
